import { Avatar_02, Avatar_03, Avatar_05, Avatar_08, Avatar_09 } from "../../Routes/ImagePath";

const defaultExport = {
    message: [
        {
            id: "1",
            image: Avatar_09,
            name: "Richard Miles",
            contents: "Lorem ipsum dolor sit amet, consectetur adipiscing",
            time: "12:28 AM",
        },
        {
            id: 2,
            image: Avatar_02,
            name: "John Doe",
            contents: "Lorem ipsum dolor sit amet, consectetur adipiscing",
            time: "6 Mar",
        },
        {
            id: 3,
            image: Avatar_03,
            name: "Tarah Shropshire",
            contents: "Lorem ipsum dolor sit amet, consectetur adipiscing",
            time: "5 Mar",
        },
        {
            id: 4,
            image: Avatar_05,
            name: "Mike Litorus",
            contents: "Lorem ipsum dolor sit amet, consectetur adipiscing",
            time: "3 Mar",
        },
        {
            id: 5,
            image: Avatar_08,
            name: "Catherine Manseau ",
            contents: "Lorem ipsum dolor sit amet, consectetur adipiscing",
            time: "27 Feb",
        },
    ]
};

export default defaultExport;
